import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import MessageComposer from './MessageComposer';
import { formatMessageTime } from '../utils/privateMessages.mjs';

export default class ConversationView extends Component {
  view() {
    const a = this.attrs;
    const t = key => app.translator.trans(`yingtao-forum-homepage.forum.private_messages.${key}`);
    if (!a.conversation) return m('div.MessageConversationView', [
      Button.component({ className: 'Button MessageBack', onclick: a.onBack }, t('back')),
      m('p', t('select_conversation')),
    ]);
    return m('section.MessageConversationView', [
      m('header', [Button.component({ className: 'Button MessageBack', onclick: a.onBack }, t('back')),
        m('h2', a.conversation.recipient.nickname),
        Button.component({ className: 'Button', disabled: a.busy, onclick: a.onBlock }, t(a.conversation.blocked ? 'unblock' : 'block'))]),
      a.conversation.blocked && m('p.MessageBlocked', t('blocked')),
      a.hasMore && Button.component({ className: 'Button', loading: a.loadingOlder, onclick: a.onOlder }, t('older')),
      m('div.MessageRows', a.messages.length ? a.messages.map(row => {
        const time = formatMessageTime(row.created_at);
        return m('article.MessageRow', {
        key: row.id, className: String(row.sender_id) === String(a.userId) ? 'MessageRow--mine' : '',
      }, [m('strong', String(row.sender_id) === String(a.userId) ? app.session.user.displayName() : a.conversation.recipient.nickname),
        m('p.MessageBody', row.body), m('time', { datetime: time.dateTime, title: time.dateTime ? `${time.text}（北京时间）` : undefined }, time.text),
        Button.component({ className: 'Button Button--link', onclick: () => a.onReport(row), disabled: a.busy }, t('report'))]);
      }) : m('p', t('empty_messages'))),
      MessageComposer.component({ draft: a.draft, sending: a.sending, onDraft: a.onDraft, onSend: a.onSend }),
    ]);
  }
}
